export default {"src":"/_next/static/media/jewel.b2e41862.svg","height":96,"width":96,"blurWidth":0,"blurHeight":0};